export const calendarInitialView = 'month';

/**
 * Required format for dateTime-local
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local#value
 */
export const textFieldMonthFormat = 'YYYY-MM-DDTHH:mm';
